import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie';

interface CreditCardStorageSettings {
  saveCards?: boolean;
}

@Injectable()
export class CreditCardStorageSettingsService {
  private baseUrl = environment.API;
  private CREDIT_CARD_STORAGE_SETTINGS_KEY = 'sc-credit-card-storage-settings';
  settings: CreditCardStorageSettings;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) {}

  private getPaymentMethods() {
    const url = `${this.baseUrl}/payments/methods/`;

    return this.http.get(url);
  }

  update(settings) {
    this.settings = settings;
    this.cookieService.putObject(this.CREDIT_CARD_STORAGE_SETTINGS_KEY, settings);
  }

  get(): CreditCardStorageSettings {
    if (this.settings) {
      return this.settings;
    }
    this.settings = this.cookieService.getObject(this.CREDIT_CARD_STORAGE_SETTINGS_KEY) || {saveCards: false};
    return this.settings;
  }

  removeCards() {
    const settings = this.get();
    if (settings.saveCards) {
      return false;
    }
    this.getPaymentMethods().subscribe((response: any) => {
      const cards = response.results;
      cards.forEach((card) => {
        const url = `${this.baseUrl}/payments/methods/${card.token}/`;
        this.http.delete(url).subscribe(() => {}, () => {});
      });
    });
  }
}
